import script from "./AdminSellerComments.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSellerComments.vue?vue&type=script&setup=true&lang=ts"

import "./AdminSellerComments.vue?vue&type=style&index=0&id=a48e3f8e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a48e3f8e"]])

export default __exports__